





















































































import MultiSelect from '@/components/MultiSelect.vue';
import {SelectBox, SelectMarket, TaskInfoCalc} from '@/interfaces/global-data';
import {GetTaskInfo, TaskInfoFilterType} from '@/interfaces/server-data';
import Http from '@/mixins/http';
import LocalData from '@/mixins/local-data';
import {IOmnichannelStrategyFilters} from '@/pages/omnichannel-strategy/types/data';
import OmnichannelStrategyApi from '@/pages/omnichannel-strategy/api/OmnichannelStrategyApi';
import {Component, Mixins, Model, Prop, Watch} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import Card from '@/components/UI/Card.vue';
import CollapseCard from '@/components/UI/CollapseCard.vue';
import DatePicker from '@/components/UI/DatePicker.vue';

@Component({
    components: {
        MultiSelect,
        vSelect,
        Card,
        CollapseCard,
    },
})
export default class OmnichannelStrategyFilters extends Mixins(LocalData, Http) {
    @Model() value!: IOmnichannelStrategyFilters;
    @Prop({required: true}) readonly api!: OmnichannelStrategyApi

    private taskInfo: TaskInfoCalc = {
        storeFormatOptions: [{value: -1, label: this.$tc('shared.selectBox.all')}],
        storeRegionOptions: [{value: -1, label: this.$tc('shared.selectBox.all')}],
        buyerSegmentOptions: [],
        categoryOptions: [{value: -1, label: this.$tc('shared.selectBox.all')}],
        clusterOptions: [{value: -1, label: this.$tc('shared.selectBox.all')}],
        groupsOfProduct: [{value: -1, label: this.$tc('shared.selectBox.all')}],
        subcategories: [],
        subcategoriesDefault: [{value: -1, label: this.$tc('shared.selectBox.all')}],
        psegemnts: [],
    };

    private defaultIntSelectBox: Array<SelectBox<number>> = [{value: -1, label: this.$tc('shared.selectBox.all')}];
    private showMainFilters: boolean = true;

    private isFormatLoading = false;
    private isRegionLoading = false;
    private isClusterLoading = false;

  mounted() {
    (this.$refs.groupOfProductRef as any).toggleLoading(true);
    (this.$refs.formatSelectedRef as any).toggleLoading(true);
    (this.$refs.categoryOfProductRef as any).toggleLoading(true);
    (this.$refs.updateRegionsRef as any).toggleLoading(true);
    (this.$refs.subcategoriesRef as any).toggleLoading(true);
    (this.$refs.clasterSelectedRef as any).toggleLoading(true);

    Promise.all([
      this.getCategoryInfo(),
      this.getRegionInfo(),
      this.getFormatInfo(),
      this.getClusterInfo(),
      this.loadProductsGroup(),
      this.loadProductsSubcategories()
    ]);
  }

  private get isGroupSelected(): boolean {
    return this.value.groupOfProduct != null && this.value.groupOfProduct > 0;
  }

  private get isCategorySelected(): boolean {
    return this.value.categoryOfProduct != null && this.value.categoryOfProduct > 0;
  }

  @Watch('value', {deep: true})
  private onFiltersChanged(newVal: IOmnichannelStrategyFilters, oldVal: IOmnichannelStrategyFilters) {
    if (typeof newVal !== 'undefined') {
      this.$emit('input', newVal, oldVal);
      this.recalculateSetState();
    }
  }

  private recalculateSetState() {
    const isFiltersSelected = this.value.market != null && this.value.market.id > 0;
    this.$emit('onFiltersSelecting', isFiltersSelected);
  }

  private get isFormatSelected(): boolean {
    if (this.isFormatLoading) {
      return false;
    }
    if (this.taskInfo.storeFormatOptions == null
        || (this.taskInfo.storeFormatOptions.length === 1 && this.taskInfo.storeFormatOptions[0].value === -1)) {
      return true
    }
    return this.value.formatSelected != null && this.value.formatSelected > 0
  }

  private get isRegionSelected(): boolean {
    if (this.isRegionLoading) {
      return false;
    }
    if (this.taskInfo.storeRegionOptions == null
        || (this.taskInfo.storeRegionOptions.length === 1 && this.taskInfo.storeRegionOptions[0].value === -1)) {
      return true
    }
    return this.value.regionSelected != null && this.value.regionSelected > 0
  }

  private get isClusterSelected(): boolean {
    if (this.isClusterLoading) {
      return false;
    }
    if (this.taskInfo.clusterOptions == null
        || (this.taskInfo.clusterOptions.length === 1 && this.taskInfo.clusterOptions[0].value === -1)) {
      return true
    }
    return this.value.clusterSelected != null && this.value.clusterSelected > 0
  }

  @Watch('value.market')
  private onMarketChangeFromParent(newMarket: SelectMarket | null, oldMarket: SelectMarket | null) {
    if (oldMarket != null && newMarket && newMarket.id !== oldMarket.id) {
      this.reloadTaskInfoAfterMarketChange();
    }
  }

  private reloadTaskInfoAfterMarketChange() {
    const refs = this.$refs;
    if (refs.groupOfProductRef) (refs.groupOfProductRef as any).toggleLoading(true);
    if (refs.categoryOfProductRef) (refs.categoryOfProductRef as any).toggleLoading(true);
    if (refs.subcategoriesRef) (refs.subcategoriesRef as any).toggleLoading(true);
    if (refs.formatSelectedRef) (refs.formatSelectedRef as any).toggleLoading(true);
    if (refs.updateRegionsRef) (refs.updateRegionsRef as any).toggleLoading(true);
    if (refs.clasterSelectedRef) (refs.clasterSelectedRef as any).toggleLoading(true);
    Promise.all([
      this.getCategoryInfo(),
      this.getRegionInfo(),
      this.getFormatInfo(),
      this.getClusterInfo(),
      this.loadProductsGroup(),
      this.loadProductsSubcategories(),
    ]);
  }

  private getCategoryInfo(cb: any = null) {
    return this.httpGetProductInfo(
        this.getTaskInfo(TaskInfoFilterType.category)
    )
        .then((data) => {
          const filterData = data.data;

          setTimeout(() => {
            (this.$refs.categoryOfProductRef as any).toggleLoading(false);
          }, 250);

          if (filterData.categories.length > 0) {
            this.taskInfo.categoryOptions = filterData.categories.map((i) => ({
              value: i.id,
              label: i.name,
            }));

            this.taskInfo.categoryOptions.unshift({
              value: -1,
              label: this.$tc('shared.selectBox.all'),
            });
          } else {
            this.value.categoryOfProduct = -1;

            this.taskInfo.categoryOptions = [
              {
                value: -1,
                label: this.$tc('shared.selectBox.all'),
              },
            ];

            this.resetData(TaskInfoFilterType.category);
          }

          if (typeof cb === 'function') {
            cb();
          }
        })
        .catch(() => {
        });
  }

  private loadProductsGroup() {
    return this.httpGetProductInfo(
        this.getTaskInfo(TaskInfoFilterType.group)
    )
        .then((data) => {
          const filterData = data.data;

          setTimeout(() => {
            (this.$refs.groupOfProductRef as any).toggleLoading(false);
          }, 250);

          if (filterData.groups.length > 0) {
            this.taskInfo.groupsOfProduct = filterData.groups.map((i) => ({
              value: i.id,
              label: i.name,
            }));

            this.taskInfo.groupsOfProduct.unshift({
              value: -1,
              label: this.$tc('shared.selectBox.all'),
            });
          } else {
            this.value.groupOfProduct = -1;

            this.taskInfo.groupsOfProduct = [
              {
                value: -1,
                label: this.$tc('shared.selectBox.all'),
              },
            ];
          }
        })
        .catch(() => {
          // оставлено пустым, как в оригинале
        });
  }


  private getTaskInfo(taskType: TaskInfoFilterType): GetTaskInfo {
    const market = this.value.market;
    if (market == null) {
      return {
        type: taskType,
        tradingId: -1,
        categories: [],
        groups: [],
        subcategory: null,
        segments: null,
        storeFormat: null,
        storeCluster: null,
        storeRegion: null,
        byReports: false,
      }

    }
    return {
      type: taskType,
      tradingId: market.id,
      categories: this.value.categoryOfProduct == null || this.value.categoryOfProduct <= 0
          ? null
          : [this.value.categoryOfProduct],
      groups: this.value.groupOfProduct == null || this.value.groupOfProduct <= 0
          ? null
          : [this.value.groupOfProduct],
      subcategory: this.value.subcategory == null || this.value.subcategory <= 0
          ? null
          : [this.value.subcategory],
      segments: null,
      storeFormat: this.value.formatSelected == null || this.value.formatSelected <= 0 ? [] : [this.value.formatSelected],
      storeCluster: this.value.clusterSelected == null || this.value.clusterSelected <= 0 ? [] : [this.value.clusterSelected],
      storeRegion: this.value.regionSelected == null || this.value.regionSelected <= 0 ? [] : [this.value.regionSelected],
      byReports: false,
    }
  }

  private resetData(type: TaskInfoFilterType) {
    switch (type) {
      case TaskInfoFilterType.group:
        this.value.categoryOfProduct = -1;
        this.value.subcategory = -1;
        this.taskInfo.categoryOptions = this.defaultIntSelectBox;
        this.taskInfo.subcategories = this.defaultIntSelectBox;
        this.value.formatSelected = -1;
        this.value.regionSelected = -1;
        this.value.clusterSelected = -1;
        (this.$refs.categoryOfProductRef as any).toggleLoading(true);
        (this.$refs.subcategoriesRef as any).toggleLoading(true);
        (this.$refs.formatSelectedRef as any).toggleLoading(true);
        (this.$refs.updateRegionsRef as any).toggleLoading(true);
        (this.$refs.clasterSelectedRef as any).toggleLoading(true);
        Promise.all([
          this.getCategoryInfo(),
          this.loadProductsSubcategories(),
          this.getFormatInfo(),
          this.getRegionInfo(),
          this.getClusterInfo()
        ]);
        break;
      case TaskInfoFilterType.category:
        this.value.subcategory = -1;
        this.taskInfo.subcategories = this.defaultIntSelectBox;
        this.value.formatSelected = -1;
        this.value.regionSelected = -1;
        this.value.clusterSelected = -1;
        (this.$refs.subcategoriesRef as any).toggleLoading(true);
        (this.$refs.formatSelectedRef as any).toggleLoading(true);
        (this.$refs.updateRegionsRef as any).toggleLoading(true);
        (this.$refs.clasterSelectedRef as any).toggleLoading(true);
        Promise.all([
          this.loadProductsSubcategories(),
          this.getFormatInfo(),
          this.getRegionInfo(),
          this.getClusterInfo()
        ]);
        break;
      case TaskInfoFilterType.subcategory:
        this.value.formatSelected = -1;
        this.value.regionSelected = -1;
        this.value.clusterSelected = -1;
        this.taskInfo.psegemnts = [];
        this.taskInfo.storeFormatOptions = this.defaultIntSelectBox;
        this.taskInfo.storeRegionOptions = this.defaultIntSelectBox;
        this.taskInfo.clusterOptions = this.defaultIntSelectBox;
        (this.$refs.formatSelectedRef as any).toggleLoading(true);
        (this.$refs.updateRegionsRef as any).toggleLoading(true);
        (this.$refs.clasterSelectedRef as any).toggleLoading(true);
        Promise.all([
          this.getFormatInfo(),
          this.getRegionInfo(),
          this.getClusterInfo()
        ]);
        break;
      case TaskInfoFilterType.format:
        this.value.regionSelected = -1;
        this.value.clusterSelected = -1;
        this.taskInfo.storeRegionOptions = this.defaultIntSelectBox;
        this.taskInfo.clusterOptions = this.defaultIntSelectBox;
        (this.$refs.updateRegionsRef as any).toggleLoading(true);
        (this.$refs.clasterSelectedRef as any).toggleLoading(true);
        Promise.all([
          this.getRegionInfo(),
          this.getClusterInfo()
        ]);
        break;
      case TaskInfoFilterType.region:
        this.value.clusterSelected = -1;
        this.taskInfo.clusterOptions = this.defaultIntSelectBox;
        (this.$refs.clasterSelectedRef as any).toggleLoading(true);
        this.getClusterInfo();
        break;
    }
  }

  private loadProductsSubcategories() {
    return this.httpGetProductInfo(
        this.getTaskInfo(TaskInfoFilterType.subcategory)
    )
        .then((data) => {
          const filterData = data.data;

          this.taskInfo.subcategories = filterData.subcategories.map((i) => ({
            value: i.id,
            label: i.name,
          }));

          this.taskInfo.subcategories.unshift({
            value: -1,
            label: this.$tc('shared.selectBox.all'),
          });

          setTimeout(() => {
            (this.$refs.subcategoriesRef as any).toggleLoading(false);
          }, 250);
        })
        .catch(() => {
        });
  }


  private updateProductGroup(groupOfProduct: number) {
        if (groupOfProduct !== this.value.groupOfProduct) {
            this.value.groupOfProduct = groupOfProduct;
            this.resetData(TaskInfoFilterType.group);
        }
    }

  private updateProductCategory(categoryOfProduct: number) {
      if (categoryOfProduct !== this.value.categoryOfProduct) {
          this.value.categoryOfProduct = categoryOfProduct;
          this.resetData(TaskInfoFilterType.category);
      }
  }

  private updateSubcategories(subcategory: number) {
      this.value.subcategory = subcategory;

  }

  private getFormatInfo() {
    this.isFormatLoading = true;

    return this.httpGetProductInfo(
        this.getTaskInfo(TaskInfoFilterType.format)
    )
        .then((data) => {
          const filterData = data.data;

          setTimeout(() => {
            (this.$refs.formatSelectedRef as any).toggleLoading(false);
          }, 500);

          this.taskInfo.storeFormatOptions = [
            {
              value: -1,
              label: this.$tc('shared.selectBox.all'),
            },
            ...filterData.storeFormat.map((i) => ({
              value: i.id,
              label: i.name,
            })),
          ];

          this.isFormatLoading = false;
          this.recalculateSetState();
        })
        .catch(() => {
          // оставлено как в оригинале
        });
  }

  private updateRegions(region: number) {
    if (this.value.regionSelected !== region) {
      this.value.regionSelected = region;
      this.resetData(TaskInfoFilterType.region);
    }
  }

  private getRegionInfo() {
    this.isRegionLoading = true;

    return this.httpGetProductInfo(
        this.getTaskInfo(TaskInfoFilterType.region)
    )
        .then((data) => {
          const filterData = data.data;

          setTimeout(() => {
            (this.$refs.updateRegionsRef as any).toggleLoading(false);
          }, 500);

          this.taskInfo.storeRegionOptions = [
            {
              value: -1,
              label: this.$tc('shared.selectBox.all'),
            },
            ...filterData.storeRegion.map((i) => ({
              value: i.id,
              label: i.name,
            })),
          ];

          this.isRegionLoading = false;
          this.recalculateSetState();
        })
        .catch(() => {
        });
  }

  private updateCluster(cluster: number) {
    if (cluster !== this.value.clusterSelected) {
      this.value.clusterSelected = cluster;
      this.resetData(TaskInfoFilterType.cluster);
    }
  }

  private getClusterInfo() {
    this.isClusterLoading = true;

    return this.httpGetProductInfo(
        this.getTaskInfo(TaskInfoFilterType.cluster)
    )
        .then((data) => {
          const filterData = data.data;

          setTimeout(() => {
            (this.$refs.clasterSelectedRef as any).toggleLoading(false);
          }, 500);

          this.taskInfo.clusterOptions = [
            {
              value: -1,
              label: this.$tc('shared.selectBox.all'),
            },
            ...filterData.storeCluster.map((i) => ({
              value: i.id,
              label: i.name,
            })),
          ];

          this.isClusterLoading = false;
          this.recalculateSetState();
        })
        .catch(() => {
        });
  }
}

